import React, { Component } from "react";
import Prospect from "./Prospect";
import { Dialog, DialogContent, DialogTitle } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import SimpleReactValidator from "simple-react-validator";
import Demographics from "./Demographics";
import DataTable from "../../Utils/GenericUI/DataTable";
import { connect } from "react-redux";
import { PROSPECT_TABLE_HEADER as header } from "../../Utils/StaticData/DashboardHeader";
import Calls from "./Calls";
import {
  PROSPECT_MANAGEMENT_INITIAL_STATE,
  PROSPECT_MANAGEMENT_CALLS_INITIAL_STATE,
} from "../initialState";
import Modal from "./Modal";
import { handleDateChange } from "../../Utils/DateFormatter";
import * as DateUtil from "../../Utils/DatePicker";
import { saveAs } from "file-saver";
import SoaDocument from "./../soapdf/SoaDocument";
import { pdf } from "@react-pdf/renderer";
import {
  setEnrollRedirect,
  clearprospectrowData,
  ProspectManagementSaveSoa,
  ProspectManagementSaveDemographics,
  ProspectManagementSaveProspect,
  searchProspect,
  getAgentList,
  loadCallsData,
  setCallerId,
  getCommentsData,
  ProspectManagementSaveCalls,
  setProspectRowData,
  loadDemographics,
  addNewComment,
  loadSoa,
  yearSelection,
  loadprospectrowData,
  getZipCodes,
  getCityList,
  getAuthrelations,
  setStateParams,
  getPlans,
  setFormData,
  planSelectionContinue,
  getCallsDataOnRowSelect,
  loadCampaignNames,
  clearProspectData,
  clearSoaData,
  SoapdfDownload,
} from "../../Redux/Actions/webAppActions";
import * as URL from "../../Redux/API_URL";
import axios from "../../Utils/http";
import history from "../../Utils/History";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import { INITIAL_STATE } from "../initialState";
import { AssignProspect } from "./AssignProspect";
import { VERDA_CONSTS } from "../../Utils/StaticData/Constant";
import Appointments from "../../components/prospectManagement/Appointments"
// import Document from "./Document";
class ProspectdashboardPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newProspect: false,
      prospectManagement: "prospect",
      callsTableData: this.props.callsTable,
      callCommentTableData: this.props.commentTableData,
      rowsPerPage: 10,
      rowsPerPageCalls: 10,
      rowsPerPageComment: 10,
      selectedRowIndex: 0,
      selectedRowIndexCalls: 0,
      selectedRowIndexComments: 0,
      RpopUp: false,
      data: { ...PROSPECT_MANAGEMENT_INITIAL_STATE },
      callsdata: { ...PROSPECT_MANAGEMENT_CALLS_INITIAL_STATE },
      addComment: false,
      isRowSelectedInCalls: false,
      isRowSelectedInProspect: false,
      key: 1,
      pdfFlag: false,
      enrollFlag: false,
      snackBarOpen: false,
      vertical: "top",
      horizontal: "center",
      snackBarSeverty: "",
      snackBarMsg: "",
      validZip: true,
      prospectSaveFlag: false,
      demographicsSave: false,
      callsSaveFlag: false,
      prospectpreviousSelectedData: {},
      demographicspreviousSelectedData: {},
      soapreviousSelectedData: {},
      callspreviousSelectedData: {},
      prospectSaved: false,
      demographicsSaved: false,
      mandatoryMbi: "",
      doubleClick: 0,
      currentProspectRowData: {},
      filteredCity: [],
    };
    this.validator = new SimpleReactValidator();
  }
  async componentDidMount() {
    // let prospectdatares=
    await this.props.loadprospectrowData({
      leadIdNbr: this.props.prospectName[0]?.value,
    });
    this.setState({
      ...this.state,
      newProspect: false,
      leadIdNbr: this.props.prospectName[0]?.value,
      isRowSelectedInProspect: true,
      data: {
        ...this.state.data,
        firstName: this.props.prospectrowSelectData?.firstName ?? "",
        lastName: this.props.prospectrowSelectData?.lastName ?? "",
        middleInitial: this.props.prospectrowSelectData?.middleInitial,
        mbi: this.props.prospectrowSelectData?.mbi,
        planCampaignName: this.props.prospectrowSelectData?.planCampaignId,
        eligibleForPartA: this.props.prospectrowSelectData?.eligibleForPartA,
        eligibleForPartB: this.props.prospectrowSelectData?.eligibleForPartB,
        eligibleForPartD: this.props.prospectrowSelectData?.eligibleForPartD,
        assignedTo: this.props.prospectrowSelectData?.assignedTo,
        statusType: this.props.prospectrowSelectData?.statusType,
        leadIdNbr: this.props.prospectrowSelectData?.leadIdNbr,
        dob: this.props.prospectrowSelectData?.dob,
        gender: this.props.prospectrowSelectData?.gender,
        preferredLang: this.props.prospectrowSelectData?.preferredLang,
        permissionToContact:
          this.props.prospectrowSelectData?.permissionToContact,
        planType: this.props.prospectrowSelectData?.planType ?? "",
        createdTime: this.props.prospectrowSelectData?.createdTime,
        createdBy: this.props.prospectrowSelectData?.createdBy,
        updatedTime: this.props.prospectrowSelectData?.updatedTime,
        updatedBy: this.props.prospectrowSelectData?.updatedBy,
      },
    });
    if (this.props?.demographicsData) {
      if (this.props.demographicsData.zip) {
        await this.props.getZipCodes(this.props.demographicsData.zip);
        await this.props.getCityList({
          zipCd: this.props.demographicsData.zip,
        });
      }
      if (this.props?.demographicsData.county) {
        let filteredCity2 = [];
        filteredCity2 = (this.props.cityList??[]).filter(
          (city) =>
            city.countyCode?.trim() ===
            this.props?.demographicsData.county?.trim()
        );
        await this.setState({
          filteredCity: filteredCity2,
        });
      }
      await this.setState({
        data: {
          ...this.state.data,
          primaryAddress1:
            this.props.demographicsData.primaryAddress1 === null
              ? ""
              : this.props.demographicsData.primaryAddress1,
          primaryAddress2:
            this.props.demographicsData.primaryAddress2 === null
              ? ""
              : this.props.demographicsData.primaryAddress2,
          city:
            this.props.demographicsData.city === null
              ? ""
              : this.props.demographicsData.city,
          state:
            this.props.demographicsData.state === null
              ? ""
              : this.props.demographicsData.state,
          zip:
            this.props.demographicsData.zip === null
              ? ""
              : this.props.demographicsData.zip,
          zipPlus4:
            this.props.demographicsData.zipPlus4 === null
              ? ""
              : this.props.demographicsData.zipPlus4,
          county:
            this.props.demographicsData.county === null
              ? ""
              : this.props.zipCodes.filter(
                  (cntyName) =>
                    cntyName?.countyCode === this.props?.demographicsData?.county
                )[0]?.countyName,
          contactPreference:
            this.props.demographicsData.contactPreference === null
              ? ""
              : this.props.demographicsData.contactPreference,
          emailAddress:
            this.props.demographicsData.emailAddress === null
              ? ""
              : this.props.demographicsData.emailAddress,
          homePhone:
            this.props.demographicsData.homePhone === null
              ? ""
              : this.props.demographicsData.homePhone,
          cellPhone:
            this.props.demographicsData.cellPhone === null
              ? ""
              : this.props.demographicsData.cellPhone,
          bestTimeToCall:
            this.props.demographicsData.bestTimeToCall === null
              ? ""
              : this.props.demographicsData.bestTimeToCall,
        },
      });
    }
    // if(prospectdatares?.status==="OK"){
    //   await this.props.setProspectRowData(prospectdatares?.data);
    // }

    if (!this?.props?.isSuperUser) {
      this.setState({
        data: {
          ...this.state.data,
          assignedTo: this?.props?.loginagentId
            ? this?.props?.loginagentId?.trim()
            : "",
        },
      });
    }
    await this.props.getAuthrelations(this.props?.customerId);
    if (
      this.props.prospectagentList?.length === 1 ||
      this.props.prospectagentList === undefined
    ) {
      await this.props.getAgentList(this.props?.customerId);
      
    }

    if (
      this.props.campaignNames?.length === 1 ||
      this.props.campaignNames === undefined
    ) {
      await this.props.loadCampaignNames();
    }
  }
  componentDidUpdate(prevState, prevProps) {
    if (prevState.callsTable != this.props.callsTable) {
      this.setState({ callsTableData: this.props.callsTable });
    }
  }

  prospectData = (event) => {
    event.preventDefault();
    this.setState(() => ({
      prospectManagement: "prospect",
      isRowSelectedInCalls: false,
    }));
  };
  demographicsData = async (event) => {
    this.setState(() => ({
      prospectManagement: "demographics",
      isRowSelectedInCalls: false,
    }));
  };

  callsData = async (event) => {
    this.setState(() => ({
      prospectManagement: "calls",
    }));
    const callsDatares = this.props.loadCallsData({
      leadIdNbr: this.state?.leadIdNbr,
    });
    if (callsDatares?.status === "OK")
      await this.setState({
        callsTableData: this.props.callsTable,
      });
  };
  appointmentHandler=()=>{
    if(this.state?.leadIdNbr){
  this.setState(() => ({
  prospectManagement: "appointments"
}))
}else{
this.setState({
  snackBarOpen: true,
  snackBarMsg: "Lead Id number is not available.",
  snackBarSeverty: "error",
});
}
  }
  handleChangeRowsPerPage = async (rowsPerPage) => {
    this.setState(() => ({
      rowsPerPage: rowsPerPage,
    }));
  };
  handleChangeRowsPerPageCalls = async (rowsPerPage) => {
    this.setState(() => ({
      rowsPerPageCalls: rowsPerPage,
    }));
  };
  handleChangeRowsPerPageCmtTable = async (rowsPerPage) => {
    this.setState(() => ({
      rowsPerPageComment: rowsPerPage,
    }));
  };
 

  
  rowSelectComment = async (index, selectedData, rowsPerPage, type) => {};
  rowSelect = async (index, selectedData, rowsPerPage, type) => {
    await this.props.getCallsDataOnRowSelect({ callId: selectedData.callId });
    //await this.props.getCommentsData({ callId:selectedData.callId});
    this.setState({
      callsdata: {
        ...this.state.callsdata,
        contactName: this.props.callsRowData?.contactName,
        lastName: this.props.callsRowData?.lastName,
        relation: this.props.callsRowData?.relation,
        dateOfCall: this.props.callsRowData?.dateOfCall,
        comment:
          this.props.callsRowData?.comment === null
            ? ""
            : this.props.callsRowData?.comment,
      },
    });
    this.setState(() => ({
      rowsPerPage: rowsPerPage,
      selectedRowIndexCalls: index,
    }));
    if (type === "ROWSELECT") {
      await this.props.setCallerId(selectedData.callId);

      await this.props.getCommentsData({ callId: this.props.callerID });
      await this.setState(() => ({
        ...this.state,
        isRowSelectedInCalls: true,
        callCommentTableData: this.props.commentTableData,
      }));
    }
  };

  // }
  openModal = () => async (e) => {
    e.preventDefault();
    this.setState({
      //prospectManagement:"soa",
      RpopUp: true,
    });
    // const collection = document.getElementsByClassName("modal-backdrop show");
    if (this.state?.leadIdNbr) {
      let payload = {
        leadIdNbr: this.state?.leadIdNbr,
      };
      const demoresponse = await this.props.loadDemographics(payload);
      if (demoresponse?.status === "OK") {
        if (
          demoresponse?.data?.zip === "" ||
          demoresponse?.data?.zip === null ||
          demoresponse?.data?.zip?.length < 5 ||
          demoresponse?.data?.county === null ||
          demoresponse?.data?.county === ""
        ) {
          this.setState({
            snackBarOpen: true,
            snackBarMsg: "Please fill the mandatory fields in demographics.",
            snackBarSeverty: "error",
          });

          return;
        } else {
          await this.props.setStateParams("zipCodes", []);
          await this.props.getZipCodes(demoresponse.data.zip);
          // await this.props.getAuthrelations()
          if (
            this.props.zipCodes.length === 0 ||
            this.props.zipCodes === null
          ) {
            this.setState({
              snackBarOpen: true,
              snackBarMsg: "Valid county or Zip code code is not available.",
              snackBarSeverty: "warning",
            });
            return;
          }

          await this.props.setStateParams("zip", demoresponse.data.zip);
          if (this.props.zipCodes && this.props.zipCodes.length === 1) {
            await this.props.setStateParams(
              "county",
              this.props.zipCodes[0].countyName
            );
          }
          if (this.props.zipCodes && this.props.zipCodes.length > 1) {
            let county = this.props.zipCodes.filter(
              (cnt) => cnt.countyCode === demoresponse.data.county
            )[0];
            if (county != undefined) {
              await this.props.setStateParams("county", county.countyName);
            }
          }
          const params = this.props.zipCodes.filter(
            (zipcode1) => zipcode1.countyCode === demoresponse.data.county
          );
          const soaresponse = await this.props.loadSoa(payload);
            if (soaresponse.status === "OK") {
              await this.setState({
                data: {
                  ...this.state.data,
                  agentName: this.props.SOAData.agentName,
                  agentPhone: this.props.SOAData.agentPhone,
                  agentSign: this.props.SOAData.agentSign,
                  appointmentDateComp: this.props.SOAData.appointmentDateComp,
                  beneAddress: this.props.SOAData.beneAddress,
                  beneName: this.props.SOAData.beneName,
                  benePhone: this.props.SOAData.benePhone,
                  beneRepSignDate: this.props.SOAData.beneRepSignDate,
                  beneRepSignature: this.props.SOAData.beneRepSignature,
                  initialMethodOfContact:
                    this.props.SOAData.initialMethodOfContact,
                  salesChannelOth: this.props.SOAData?.salesChannelOth,
                  productName: this.props.SOAData.productName,
                  relationshipToBene: this.props.SOAData.relationshipToBene,
                  repName: this.props.SOAData.repName,
                  isAuthRep:
                    this.props?.SOAData?.repName?.length > 0 &&
                    this.props?.SOAData?.relationshipToBene?.length > 0
                      ? "YES"
                      : "NO",
                  beneBirthDate: this.props.SOAData?.beneBirthDate,
                  agentSignDate: this.props.SOAData?.agentSignDate,
                  beneficiaryInitial: this.props.SOAData?.beneficiaryInitial ?? "",
                  medicaidId: this.props.SOAData?.medicaidId ?? "",
                  planYear: this.props.SOAData?.planYear ?? "",
                },
              });
            }
            
          if (params.length > 0) {
            await this.props.getPlans(
              demoresponse.data.zip,
              params[0].countyCode,
              this.props?.customerId,
              params[0].stateCode,
              this.props?.SOAData?.planYear
                ? this.props?.SOAData?.planYear
                : this.props?.year
              // this.props?.year
            );
          } else {
            await this.props.setStateParams("planCardData", []);
          }
          if (this.props.planCardData.length === 0) {
            this.setState({
              snackBarOpen: true,
              snackBarMsg: "No product Name are available in SOA.",
              snackBarSeverty: "warning",
            });

            return;
          } else {
            if (soaresponse.status === "OK") {
              await this.setState({
                soapreviousSelectedData: {
                  leadIdNbr: this.props.leadIdNbr,
                  customerId: this.props?.customerId,
                  beneRepSignature: this.props.SOAData.beneRepSignature,
                  salesChannelOth: this.props?.SOAData?.salesChannelOth,
                  captureBeneRepSign: this.props.SOAData.captureBeneRepSign,
                  beneRepSignDate: this.props.SOAData.beneRepSignDate,
                  relationshipToBene: this.props.SOAData.relationshipToBene,
                  repName: this.props.SOAData.repName,
                  productName: this.props.SOAData.productName,
                  agentName: this.props.SOAData.agentName,
                  agentPhone: this.props.SOAData.agentPhone,
                  agentSign: this.props.SOAData.agentSign,
                  appointmentDateComp: this.props.SOAData.appointmentDateComp,
                  beneName: this.props.SOAData.beneName,
                  benePhone: this.props.SOAData.benePhone,
                  beneAddress: this.props.SOAData.beneAddress,
                  initialMethodOfContact:
                    this.props.SOAData.initialMethodOfContact,
                  isAuthRep:
                    this.props?.SOAData?.repName?.length > 0 &&
                    this.props?.SOAData?.relationshipToBene?.length > 0
                      ? "YES"
                      : "NO",
                },
                data: {
                  ...this.state.data,
                  agentName: this.props.SOAData.agentName,
                  agentPhone: this.props.SOAData.agentPhone,
                  agentSign: this.props.SOAData.agentSign,
                  appointmentDateComp: this.props.SOAData.appointmentDateComp,
                  beneAddress: this.props.SOAData.beneAddress,
                  beneName: this.props.SOAData.beneName,
                  benePhone: this.props.SOAData.benePhone,
                  beneRepSignDate: this.props.SOAData.beneRepSignDate,
                  beneRepSignature: this.props.SOAData.beneRepSignature,
                  initialMethodOfContact:
                    this.props.SOAData.initialMethodOfContact,
                  salesChannelOth: this.props.SOAData?.salesChannelOth,
                  productName: this.props.SOAData.productName,
                  relationshipToBene: this.props.SOAData.relationshipToBene,
                  repName: this.props.SOAData.repName,
                  isAuthRep:
                    this.props?.SOAData?.repName?.length > 0 &&
                    this.props?.SOAData?.relationshipToBene?.length > 0
                      ? "YES"
                      : "NO",
                  beneBirthDate: this.props?.SOAData?.beneBirthDate,
                  agentSignDate: this.props?.SOAData?.agentSignDate,
                  planYear: this.props?.SOAData?.planYear
                    ? this.props?.SOAData?.planYear
                    : new Date().getFullYear().toString(),
                  beneficiaryInitial: this.props.SOAData?.beneficiaryInitial,
                  medicaidId: this.props.SOAData?.medicaidId ?? "",
                },
              });
            }
            this.setState({
              //prospectManagement:"soa",
              RpopUp: true,
              addComment: false,
              isRowSelectedInCalls: false,
            });
          }
        }
      } else {
        this.setState({
          snackBarOpen: true,
          snackBarMsg: "Demographics is empty please fill first",
          snackBarSeverty: "error",
        });

        return;
      }
    } else {
      this.setState({
        snackBarOpen: true,
        snackBarMsg: "Lead Id number is not available.",
        snackBarSeverty: "error",
      });

      return;
    }

    return;
  };
 
 
 
  modalClosed = () => {
    this.props.clearSoaData();
    this.setState({
      RpopUp: false,
      data: { ...this.state.data, agentName: "" },
    });
    var inputs = document.getElementsByTagName("input");
    for (var i = 0; i < inputs.length; i++) {
      inputs[i].disabled = false;
    }
  };
  handleOtherDropdown = (name) => async (event) => {
    const value = event.target
      ? event.target.value
      : event.value || event.label;
    if (name === "relation") {
      await this.setState({
        callsdata: { ...this.state.callsdata, [name]: value },
      });
    }
    if (name === "county") {
      await this.setState({ data: { ...this.state.data, [name]: value } });
      // let filtered = this.props.zipCodes.filter(
      //   (data1) => data1.countyName === value
      // );
      // await this.setState({
      //   data: {
      //     ...this.state.data,
      //     state: filtered[0]?.stateCd,
      //     city: filtered[0]?.cityName,
      //   },
      // });

      let filteredCity = [];

      filteredCity = this.props.cityList.filter(
        (city) => city.countyName.trim() === value?.trim()
      );

      await this.setState({
        filteredCity: filteredCity,
      });

      if (filteredCity?.length >= 1) {
        this.setState({
          ...this.state,
          data: {
            ...this.state.data,
            city: filteredCity[0].cityName,
            state: filteredCity[0]?.stateCode,
          },
        });
      }
    } else {
      await this.setState({ data: { ...this.state.data, [name]: value } });
    }
  };
  handleMultipleSelectionDropdown = (name) => async (data) => {
    let multipleValues = [];
    data.forEach((data1) => {
      multipleValues.push(data1.value);
    });
    if (name == "bestTimeToCall") {
      if (
        this.state.data.bestTimeToCall.length === 0 &&
        multipleValues.indexOf("") !== -1
      ) {
        multipleValues.splice(multipleValues.indexOf(""), 1);
      } else if (
        this.state.data.bestTimeToCall.length > 0 &&
        multipleValues.indexOf("") !== -1
      ) {
        multipleValues = [];
      }
    }
    if (name == "contactPreference") {
      if (
        this.state.data.contactPreference.length === 0 &&
        multipleValues.indexOf("") !== -1
      ) {
        multipleValues.splice(multipleValues.indexOf(""), 1);
      } else if (
        this.state.data.contactPreference.length > 0 &&
        multipleValues.indexOf("") !== -1
      ) {
        multipleValues = [];
      }
    }
    await this.setState({
      data: { ...this.state.data, [name]: multipleValues },
    });
  };
  handleDropdown = (name) => async (event) => {
    // let value = event.target
    //   ? event.target.label
    //   : event.label || event.value;
    let value = event.target ? event.target.value : event.value || event.label;
    if (value === "---Select---") {
      value = "";
    }
    this.setState({ data: { ...this.state.data, [name]: value } });
  };
  OnBlurEmailAddr = (e) => {
    e.preventDefault();
    let isValidEmail = this.validator.check(
      this.state.data.emailAddress,
      "email"
    );
    if (!isValidEmail) {
      this.setState({
        snackBarOpen: true,
        snackBarMsg: "Please enter valid email address.",
        snackBarSeverty: "error",
      });
    }
  };
  handleMutipleCheckbox = async (event) => {
    let name = event.target.name;
    let value = event.target.value;
    //  let multi=[]
    //let multiple=[]
    let multiple = this.state?.data?.productName;
    // ? this.state?.data?.productName
    // : [];
    if (multiple.includes(value)) {
      //let index = multiple.indexOf(value);
      //multiple.splice(index, 1);
      multiple = multiple.replace(value, "")?.replace(",,", ",");
      //removing start and end commas 2 if conditions
      if (multiple[0] === ",") {
        multiple = multiple.substring(1, multiple.length);
      }
      if (multiple[multiple.length - 1] === ",") {
        multiple = multiple.substring(0, multiple.length - 1);
      }
    } else {
      if (multiple?.length > 0) {
        multiple = multiple + "," + value;
      } else {
        multiple = value;
      }
    }
    await this.setState({ data: { ...this.state.data, [name]: multiple } });
  };
  handleChange = async (event) => {
    let name = event.target.name;
    let value = event.target.value;
    //please dont remove the below condition,else it will affect initial methd of contact radio button and soa pdf
    if (!name.includes("initialMethodOfContact")) {
      value = value.toUpperCase();
    }
    //let value = event.target.value;
    if (name.includes("zipPlus4")) {
      //value = event.target.value?.trim();
      value = event.target.value?.trim().replace(new RegExp(/[^\d]/, "ig"), "");
    }
    if (name.includes("mbi")) {
      let valid = false;
      //let count=value.length-1

      if (value.length > 0) {
        if (value != this.state.mandatoryMbi) {
          let temp = "";
          for (let i = 0; i < value.length; i++) {
            if (i === 1 || i === 4 || i === 7 || i === 8) {
              valid = value.charAt(i).match(/[A-Z]/) ? true : false;
              if (valid === true) {
                valid = !(
                  value.charAt(i) === "S" ||
                  value.charAt(i) === "L" ||
                  value.charAt(i) === "O" ||
                  value.charAt(i) === "I" ||
                  value.charAt(i) === "B" ||
                  value.charAt(i) === "Z"
                );

                if (valid === true) {
                  temp = temp + value[i];
                  //mandatoryMbi:this.state.mandatoryMbi+value[count]
                }
              }
            }
            if (i === 0 || i === 3 || i === 6 || i === 9 || i === 10) {
              valid = !isNaN(value[i]);

              if (valid === true) {
                //mandatoryMbi:this.state.mandatoryMbi+value[count]
                temp = temp + value[i];
              }
            }
            if (i === 2 || i === 5) {
              valid = value[i].match(/[A-Z]/) ? true : false;
              if (valid === true) {
                valid = !(
                  value.charAt(i) === "S" ||
                  value.charAt(i) === "L" ||
                  value.charAt(i) === "O" ||
                  value.charAt(i) === "I" ||
                  value.charAt(i) === "B" ||
                  value.charAt(i) === "Z"
                );
              }
              valid = !isNaN(value[i]) || valid;
              if (valid === true) {
                //mandatoryMbi:this.state.mandatoryMbi+value[count]
                temp = temp + value[i];
              }
            }
            if (valid === false || valid === null) {
              this.setState({
                snackBarOpen: true,
                snackBarMsg: "Please enter mbi in correct format",
                snackBarSeverty: "error",
              });
            }
          }
          this.setState({
            mandatoryMbi: temp,
            //temp:temp+value[count]
          });
        }
      } else {
        this.setState({
          mandatoryMbi: "",
          //temp:temp+value[count]
        });
      }
    }
    if (
      event.target.type === "checkbox" &&
      (name === "captureBeneficiaryCheckBox" ||
        name === "CaptureAgentSignature" ||
        name === "captureBeneRepSign" ||
        name === "isAuthRep")
    ) {
      value = event.target.checked ? "YES" : "NO";
    }
    if (name.toLowerCase().includes("phone")) {
      value = this.formatPhoneNumber(value.replace(/[^0-9]/g, ""));
    }
    if (name === "zip") {
      if (value?.length === 5) {
        await this.setState({
          filteredCity: [],
        });
        const response = await this.props.getZipCodes(value);
        await this.props.getCityList({
          zipCd: value,
        });

        if (response.data === null) {
          this.setState({
            snackBarOpen: true,
            snackBarMsg: response.message,
            snackBarSeverty: "error",
            validZip: false,
          });
        } else {
          this.setState({
            validZip: true,
            // getZipresponse:response.data
          });
          await this.props.setStateParams("zipCodes", response.data);
          if (response.data.length === 1) {
            await this.setState({
              data: {
                ...this.state.data,
                county: response?.data[0]?.countyName,
                //new
                state: response?.data[0]?.stateCd,
                city: response?.data[0]?.cityName,
              },
            });
          }
          if (response.data.length > 1 || response.data.length === 0) {
            await this.setState({
              data: { ...this.state.data, county: "", state: "", city: "" },
            });
          }
        }
      }
    }
    await this.setState({ data: { ...this.state.data, [name]: value } });
    if (this.state.data?.relationshipToBene === "SLF") {
      await this.setState({
        data: { ...this.state.data, beneName: this.state.data?.repName },
      });
    }
    if (name === "initialMethodOfContact" && value === "Other") {
      await this.setState({
        data: {
          ...this.state.data,
          initialMethodOfContact: "Other",
          salesChannelOth: "",
        },
      });
    }
  };

  formatPhoneNumber = (phoneNumberString) => {
    var match = phoneNumberString.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return "(" + match[1] + ") " + match[2] + "-" + match[3];
    }
    return phoneNumberString;
  };
  handleChangeCalls = async (event) => {
    let name = event.target.name;
    let value = event.target.value.toUpperCase();

    await this.setState({
      callsdata: { ...this.state.callsdata, [name]: value },
    });
  };
  handleDate = async (event) => {
    let name = event.target.name;
    let value = event.target.value;
    value = handleDateChange(value);
    if (value === "") {
      this.setState({
        snackBarOpen: true,
        snackBarMsg: "Please enter date in the MM/DD/YYYY format",
        snackBarSeverty: "error",
      });
    }
    await this.setState({
      data: { ...this.state.data, [name]: value },
    });
  };
  handleDate1 = async (event) => {
    let name = event.target.name;
    let value = event.target.value;
    value = handleDateChange(value);
    if (value === "") {
      this.setState({
        snackBarOpen: true,
        snackBarMsg: "Please enter date in the MM/DD/YYYY format",
        snackBarSeverty: "error",
      });
    }
    if (value?.length > 10) {
      this.setState({
        snackBarOpen: true,
        snackBarMsg: "Please enter date in the MM/DD/YYYY format",
        snackBarSeverty: "error",
        callsdata: { ...this.state.callsdata, [name]: "" },
      });
      return;
    }
    await this.setState({
      callsdata: { ...this.state.callsdata, [name]: value },
    });
  };
  handleDates = (fieldId) => {
    DateUtil.getDatePicker("#" + fieldId).datepicker("show");
    DateUtil.getDatePicker("#" + fieldId).on("change", (e) => {
      this.setDates(fieldId, e.target.value);
    });
  };
  setDates = async (fieldId, value) => {
    if (this.state.prospectManagement === "calls") {
      if (fieldId == "appointmentDateComp") {
        await this.setState({ data: { ...this.state.data, [fieldId]: value } });
      } else {
        await this.setState({
          callsdata: { ...this.state.callsdata, [fieldId]: value },
        });
      }
    } else {
      await this.setState({ data: { ...this.state.data, [fieldId]: value } });
    }
  };

  handleSnackClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({
      snackBarOpen: false,
    });
  };

  render() {
    const { vertical, horizontal, snackBarSeverty, snackBarMsg } = this.state;
    return (
      <div class="container-campaignmain prospecttablealign mt-3 mb-3">
        <Snackbar
          open={this.state.snackBarOpen}
          autoHideDuration={3000}
          onClose={this.handleSnackClose}
          anchorOrigin={{ vertical, horizontal }}
          key={this.state.vertical + this.state.horizontal}
        >
          <Alert onClose={this.handleSnackClose} severity={snackBarSeverty}>
            {snackBarMsg}
          </Alert>
        </Snackbar>
        <div></div>
        <Dialog open={this.props.dashboardmodalOpen} maxWidth="false">
          <DialogTitle class="modal-headerprospect">
            <div class="justify-content-between d-flex">
              <div class="tab-wrapper ml-1">
                <ul class="nav list">
                  <li class="position-relative">
                    <a
                      href="#prospect"
                      data-toggle="tab"
                      class={
                        this.state.prospectManagement === "prospect"
                          ? "nav-link-active prospectfont"
                          : "nav-link-normal prospectfont"
                      }
                      onClick={this.prospectData}
                    >
                      Prospect
                    </a>
                  </li>
                  <li class="position-relative">
                    <a
                      href={
                        this.state.prospectManagement === "demographics"
                          ? "#demographics"
                          : "#/"
                      }
                      data-toggle="tab"
                      class={
                        // this.state.isRowSelectedInProspect === false ||
                        // this.state.newProspect === true
                        //   ? "disable-link"
                        //   :
                        this.state.prospectManagement === "demographics"
                          ? "nav-link-active prospectfont"
                          : "nav-link-normal prospectfont"
                      }
                      onClick={this.demographicsData}
                    >
                      Demographics
                    </a>
                  </li>
                  <li class="position-relative">
                    <a
                      href={
                        this.state.prospectManagement === "calls"
                          ? "#calls"
                          : "#/"
                      }
                      data-toggle="tab"
                      class={
                        // this.state.isRowSelectedInProspect === false ||
                        // this.state.newProspect === true
                        //   ? "disable-link"
                        //   :
                        this.state.prospectManagement === "calls"
                          ? "nav-link-active prospectfont"
                          : "nav-link-normal prospectfont"
                      }
                      onClick={this.callsData}
                    >
                      Calls
                    </a>
                  </li>
                  <li class="position-relative">
                        <a
                          href={
                            this.state.prospectManagement === "appointments"
                              ? "#appointments"
                              : "#/"
                          }
                          data-toggle="tab"
                          class={
                            this.state.prospectManagement === "appointments"
                              ? "nav-link-active prospectfont"
                              : "nav-link-normal prospectfont"
                          }
                          onClick={()=>this.appointmentHandler()}
                        >
                          Appointments 
                        </a>
                      </li>
                  <li class="position-relative">
                    <a
                      href={
                        this.state.prospectManagement === "soa" ? "#soa" : "#/"
                      }
                      data-toggle="modal"
                      class={
                        // this.state.isRowSelectedInProspect === false ||
                        // this.state.newProspect === true
                        //   ? "disable-link"
                        //   :
                        this.state.prospectManagement === "soa"
                          ? "nav-link-active prospectfont"
                          : "nav-link-normal prospectfont"
                      }
                      id="soaOpen"
                      onClick={this.openModal()}
                    >
                      SOA
                    </a>
                  </li>
                  
                </ul>
              </div>

            
              {/* <IconButton
                className="modalsoacommentcloseicon noprint"
                onClick={() => {
                  this.props.closeprospectDashboardModal();
                }}
              >
                <CloseIcon />
              </IconButton> */}
              <button
                  type="button"
                  class="close mr-3"
                  onClick={() => {
                    this.props.closeprospectDashboardModal();
                  }}
                >
                  &times;
                </button>
            </div>
          </DialogTitle>
          <DialogContent>
            <div>
              <div class="row tab-content prospect-tab tab-contentSharp">
                <div
                  class={
                    this.state.prospectManagement === "prospect"
                      ? "tab-content-login111 tab-pane fade active show"
                      : "tab-content-login111 tab-pane fade"
                  }
                  id="prospect"
                >
                  <Prospect
                  disable={true}
                    prospectSaveFlag={this.state.prospectSaveFlag}
                    data={this.state.data}
                    leadIdNbr={this.state.leadIdNbr}
                    handleChange={this.handleChange}
                    handleDropdown={this.handleDropdown}
                    handleOtherDropdown={this.handleOtherDropdown}
                    handleDates={this.handleDates}
                    handleDate={this.handleDate}
                    mandatoryMbi={this.state.mandatoryMbi}
                    isRowSelectedInProspect={this.state.isRowSelectedInProspect}
                    newProspect={this.state.newProspect}
                    handleMultipleSelectionDropdown={
                      this.handleMultipleSelectionDropdown
                    }
                    isSuperUser={this?.props?.isSuperUser}
                  />
                </div>

                <>
                  <div
                    class={
                      this.state.prospectManagement === "demographics"
                        ? "tab-content-login111 tab-pane fade active show"
                        : "tab-content-login111 tab-pane fade"
                    }
                    id="demographics"
                  >
                    <Demographics
                     disable={true}
                      validator={this.validator}
                      OnBlurEmailAddr={this.OnBlurEmailAddr}
                      validZip={this.state.validZip}
                      demographicsSave={this.state.demographicsSave}
                      data={this.state.data}
                      handleChange={this.handleChange}
                      handleDate={this.handleDate}
                      handleDates={this.handleDates}
                      filteredCity={this.state.filteredCity}
                      handleOtherDropdown={this.handleOtherDropdown}
                      handleMultipleSelectionDropdown={
                        this.handleMultipleSelectionDropdown
                      }
                    />
                  </div>

                  <div
                    
                    id="soa"
                  >
                    <Modal
                     disable={true}
                      idName={"modalWidth"}
                     
                      show={this.state.RpopUp}
                      modalClosed={() => {
                        this.modalClosed();
                      }}
                     
                     
                      saveSoa={this.saveSoa}
                      inputField
                      sendButton
                      cancelButton
                      data={this.state.data}
                      handleChange={this.handleChange}
                      handleMutipleCheckbox={this.handleMutipleCheckbox}
                      handleDate={this.handleDate}
                      handleDates={this.handleDates}
                      addComment={this.state.addComment}
                      customerId={this?.props?.customerId}
                    ></Modal>
                  </div>
                  <div
                    class={
                      this.state.prospectManagement === "calls"
                        ? "tab-content-login111 tab-pane fade active show scroll container"
                        : "tab-content-login111 tab-pane fade scroll container"
                    }
                    id="calls"
                  >
                    <Calls
                      callsSaveFlag={this.state.callsSaveFlag}
                      tableData={this.state.callsTableData}
                      rowsPerPage={this.state.rowsPerPageCalls}
                      rowsPerPage1={this.state.rowsPerPageComment}
                      selectedRowIndex={this.state.selectedRowIndexCalls}
                      selectedRowIndexComments={
                        this.state.selectedRowIndexComments
                      }
                      handleChangeRowsPerPage={
                        this.handleChangeRowsPerPageCalls
                      }
                      handleChangeRowsPerPageCmtTable={
                        this.handleChangeRowsPerPageCmtTable
                      }
                      rowSelect={this.rowSelect}
                      rowSelectCmt={this.rowSelectComment}
                      commenttableData={this.state.callCommentTableData}
                      
                      data={this.state.callsdata}
                      handleChange={this.handleChangeCalls}
                      handleDates={this.handleDates}
                      handleDate={this.handleDate1}
                      isRowSelectedInCalls={this.state.isRowSelectedInCalls}
                      authorizedrelations={this.props.authorizedrelations}
                      handleOtherDropdown={this.handleOtherDropdown}
                    />
                  </div>
                  {this.state.prospectManagement==="appointments" &&
                  <div
                          class={
                            this.state.prospectManagement === "appointments"
                              ? "tab-content-login111 tab-pane fade active show scroll container"
                              : "tab-content-login111 tab-pane fade scroll container"
                          }
                          id="appointments"
                        >
                          <Appointments
                          leadIdNbr={this.state?.leadIdNbr}
                          />
                        </div>
  }
                </>

              
              </div>
            </div>
          </DialogContent>

          <div class="modal-footer">
            <button
              class="btn btn-campaign"
              data-dismiss="modal"
              onClick={() => this.props.closeprospectDashboardModal()}
            >
              Close
            </button>
          </div>
        </Dialog>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    year: state.webApp.year?.planYear
      ? state.webApp.year.planYear
      : state.webApp.year,
    agentFullName: state.login.agentFullName,
    loginagentId: state.login.agentId,
    agentEmailId: state.login.agentEmailId,
    customerId: state.login.customerId,
    lang: state.webApp.language,
    successignUp: state.login.successfulSignUp,
    prospectTable: state.campaignProspect.prospectTableData,
    // prospectagentList: state.campaignProspect.agentList,
    prospectagentList: state.webApp.membershipAgentList,
    callsTable: state.campaignProspect.callsTableData,
    callerID: state.campaignProspect.callerID,
    commentTableData: state.campaignProspect.commentTableData,
    leadIdNbr: state.campaignProspect.leadIdNbr,
    token: state.login.token,
    demographicsData: state.campaignProspect.demographicsData,
    SOAData: state.campaignProspect.SOAData,
    prospectrowSelectData: state.campaignProspect.prospectrowData,
    planCardData: state.webApp.planCardData,
    prospect: state.campaignProspect.prospectStateEntry,
    callsRowData: state.campaignProspect.callsRowData,
    search: state.webApp.search,
    zipCodes: state.webApp.zipCodes,
    campaignNames: state.campaignProspect.campaignNamesList,
    isLoading: state.spinner.isLoading,
    //authorizedrelations:state.webApp.authorizedrelations,
    authorizedrelations: state.campaignProspect.Authrelation,
    isAgentRole: state.webApp.isAgentRole,
    isSuperUser: state.webApp.isSuperUser,
    agentId: state.webApp.agentId,
    cityList: state.login.cityList,
  };
};
const mapDispatchToProps = {
  setEnrollRedirect,
  clearprospectrowData,
  getCallsDataOnRowSelect,
  loadSoa,
  loadprospectrowData,
  ProspectManagementSaveCalls,
  ProspectManagementSaveSoa,
  ProspectManagementSaveProspect,
  getAgentList,
  searchProspect,
  ProspectManagementSaveDemographics,
  loadCallsData,
  setCallerId,
  getCommentsData,
  addNewComment,
  setProspectRowData,
  loadDemographics,
  yearSelection,
  getZipCodes,
  getCityList,
  getAuthrelations,
  setStateParams,
  getPlans,
  setFormData,
  planSelectionContinue,
  loadCampaignNames,
  clearProspectData,
  clearSoaData,
  SoapdfDownload,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProspectdashboardPopup);
